import React, { FC, useEffect } from 'react';

const ClearLogin: FC = () => {

  useEffect(() => {
    localStorage.clear();
  }, [ /* on did mount */]);

  return (
    <br />
  );

};

export default ClearLogin;
